export default function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-align@2.3.6@rc-align/es/isWindow.js
// module id = 438
// module chunks = 0 1